<h1 class="h1">{{translations.title}}</h1>
<vue-server-messages [messages]="messages"></vue-server-messages>
<vue-panel i18nBundle="AccountRecovery" class="app-container">
  <div>
    <p class="h5">{{translations.usernameLabel}}</p>
    @if (user) {
      <p  id="username">{{user.userName}}</p>
    }
  </div>

  <div class="btn-section form-btn-section">
    <a class="href_link"
      (click)="goToPasswordResetPage()"
      tabindex="0">
      {{translations.passwordResetText}}
    </a>
    <button class="btn btn-primary btn-right"
      [innerText]="translations.returnToLogin"
      (click)="returnToLogin()">
    </button>
  </div>
</vue-panel>
<app-webng-redirect-form [submitEmitter]="redirectToWebNGFormEventEmitter"></app-webng-redirect-form>
